export const FirearmMakeConstants = {
    NOT_ON_LIST: '27fda556-b200-4d8e-ad69-d7fa3b2c9dcf'
}